import { generatePrimitiveSchema, generateRootObjectSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";

export const generateGraffitiCardSpecification = (name: string, rendererBaseUrl: string, editorBaseUrl: string, variantId: string) => new BaseAtomSpec(name, generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  rendererUrl: generatePrimitiveSchema("string", " ", "", { format: "graffiti", defaultValue: rendererBaseUrl, extra: { graffiti: { editorBaseUrl, variantId } } })
}, { required: [ "rendererUrl" ] }));
